import { omit } from 'lodash';
import { Moment } from 'moment';
import User from '@/shared/models/User';
import { isPresent } from '@/shared/utils/typescript';
import WorkPreparationStatus from '../constants/WorkPreparationStatus';
import { WorkPreparationReasonId } from './WorkPreparationReason';
import { WorkPreparationRoleId } from './WorkPreparationRole';

export interface WorkPreparationItemId {__workPreparationId: number;}

export default class WorkPreparationItem {
  id: WorkPreparationItemId | null = null;
  title = '';
  status = WorkPreparationStatus.TO_DO;
  comment = '';
  reasonId: WorkPreparationReasonId | null = null;
  editable = false;
  modifiedOn: Moment | null = null;
  modifiedBy: User | null = null;
  approved = false;
  roleId: WorkPreparationRoleId | null = null;

  canBeCleared(): boolean {
    return isPresent(this.id);
  }

  clear(): void {
    this.updateWith(new WorkPreparationItem());
  }

  updateWith(that: WorkPreparationItem): void {
    Object.assign(this, omit(that, 'title', 'editable'));
  }
}